import { Controller } from "@hotwired/stimulus"

// Saves one cell on the class-picture print tracking screen (a note, or the
// number actually printed) without submitting a form. Mirrors
// auto_save_class_photo_export_controller: PATCH on change, revert on failure.
//
// One controller for both fields rather than two near-identical ones -- the field
// name travels in a value, and the endpoint decides what it means.
export default class extends Controller {
  static values = { url: String, field: String }

  save(event) {
    const input = event.target
    const previous = typeof input.dataset.previousValue === "string"
      ? input.dataset.previousValue
      : input.defaultValue
    input.disabled = true

    const body = {}
    body[this.fieldValue] = input.value

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify(body)
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.status)
        return response.json()
      })
      .then((data) => {
        input.disabled = false
        input.value = data[this.fieldValue]
        input.dataset.previousValue = input.value
        input.style.backgroundColor = "#dff0d8"
        setTimeout(() => { input.style.backgroundColor = "" }, 600)
      })
      .catch(() => {
        // Put the old value back rather than leaving the screen claiming a save
        // that did not happen -- this number drives what gets reprinted.
        input.disabled = false
        input.value = previous
        input.style.backgroundColor = "#f2dede"
      })
  }
}
